export type Language = 'pt-BR' | 'en' | 'es'

export const translations = {
  'pt-BR': {
    // Header
    startProject: 'Iniciar Projeto',
    aboutUs: 'Sobre Nós',
    findYourSport: 'Encontre seu Esporte',
    shop: 'Loja',
    country: 'Brasil (USD $)',

    // Form Header - Novo estilo comercial
    title: 'Simule seu Uniforme',
    subtitle: 'Receba uma estimativa de custo em menos de 2 minutos',
    desc1: 'Preencha o formulário e receba uma proposta personalizada.',
    desc2: 'Pedido mínimo:',
    desc2Bold: '10 peças',
    desc3: 'Entrega em todo Brasil.',
    
    // Estimativa em tempo real
    estimateTitle: 'Sua Estimativa',
    estimateRange: 'Valor estimado',
    estimateDelivery: 'Prazo estimado',
    estimateDiscount: 'Desconto por quantidade',
    estimateTip: 'Acima de 30 peças você economiza até 10%',
    estimateWeeks: 'semanas',
    estimateDays: 'dias',
    estimateFrom: 'a partir de',
    
    // Perfil do cliente
    customerProfileTitle: 'Qual é o seu perfil?',
    customerProfileDesc: 'Isso nos ajuda a personalizar sua proposta.',
    profileTeam: 'Time/Clube',
    profileTeamDesc: 'Uniforme para equipe esportiva',
    profileCompany: 'Empresa',
    profileCompanyDesc: 'Uniforme corporativo ou promocional',
    profileEvent: 'Evento',
    profileEventDesc: 'Uniforme para evento específico',
    profileReseller: 'Revenda',
    profileResellerDesc: 'Compra para revender',
    
    // Quantidade com inteligência comercial
    quantityTitle: 'Quantas peças você precisa?',
    quantityDesc: 'Selecione a quantidade estimada.',
    quantityTip10: 'Pedido mínimo',
    quantityTip30: 'Melhor custo-benefício',
    quantityTip50: '15% de desconto',
    quantityTip100: '20% de desconto - Atacado',
    quantityWarning: 'Pedido mínimo de 10 peças',
    
    // Personalização
    personalizationTitle: 'Personalização',
    personalizationDesc: 'O que seu uniforme vai ter?',
    hasNameNumber: 'Nome e número nas costas?',
    hasNameNumberYes: 'Sim, cada peça terá nome/número',
    hasNameNumberNo: 'Não, uniforme padrão',
    hasCustomDesign: 'Design personalizado?',
    hasCustomDesignYes: 'Sim, quero um design exclusivo',
    hasCustomDesignNo: 'Não, posso usar templates',
    
    // Urgência
    urgencyTitle: 'Qual a urgência?',
    urgencyDesc: 'O prazo afeta o valor final.',
    urgencyNormal: 'Normal',
    urgencyNormalDesc: '4-6 semanas',
    urgencyUrgent: 'Urgente',
    urgencyUrgentDesc: '2-3 semanas (+25%)',
    
    // Local/Entrega
    cityLabel: 'Cidade',
    deliveryMethodTitle: 'Como prefere receber?',
    deliveryPickup: 'Retirar no local',
    deliveryDelivery: 'Entrega no endereço',
    
    // Contato
    contactTitle: 'Seus dados de contato',
    contactDesc: 'Entraremos em contato para finalizar sua proposta.',
    companyNameLabel: 'Nome da empresa (opcional)',
    whatsappLabel: 'WhatsApp',
    
    // Resultado/Estimativa final
    resultTitle: 'Sua Estimativa',
    resultSubtitle: 'Baseado nas suas seleções',
    resultPrice: 'Valor estimado',
    resultDelivery: 'Prazo de entrega',
    resultRecommendation: 'Recomendação',
    resultCTA: 'Receber Proposta Completa',
    resultNote: 'Esta é uma estimativa. O valor final pode variar.',
    
    // Gatilhos de valor
    valueQuality: 'Qualidade profissional',
    valueDelivery: 'Entrega garantida',
    valueDifferential: 'Design exclusivo',

    // Featured on Social
    featuredTitle: 'Gostaria que seu projeto fosse apresentado nos canais de mídia social da JerseyBird?',
    learnMore: 'Saiba mais',
    yes: 'Sim',
    no: 'Não',

    // Sport Selection
    selectSport: 'Selecione seu esporte',
    soccer: 'Futebol',
    basketball: 'Basquete',
    baseball: 'Beisebol',
    hockey: 'Hóquei',
    football: 'Futebol Americano',
    lacrosse: 'Lacrosse',
    rugby: 'Rugby',
    track: 'Atletismo',
    other: 'Outro',

    // Program Selection
    selectProgram: 'Selecione seu programa',
    programDescription: 'Escolha o programa que se adapta ao seu cronograma e necessidades de design. O prazo total inclui design, produção e envio.',
    standardTitle: 'JerseyBird Standard (Controle total, kits totalmente personalizados)',
    standardFeature1: 'Designs totalmente personalizados',
    standardFeature2: 'Opções de upgrade disponíveis',
    standardFeature3: '6-8 semanas de prazo total',
    speedrunTitle: 'JerseyBird SpeedRun (Entrega mais rápida, opções de design limitadas)',
    speedrunFeature1: 'Designs baseados em templates',
    speedrunFeature2: 'Sublimação completa, upgrades limitados',
    speedrunFeature3: '4-5 semanas de prazo total',

    // Athletes
    estimatedAthletes: 'Número estimado de atletas no seu programa/time',
    selectPlaceholder: 'Selecione...',

    // More than jerseys
    orderMoreTitle: 'Você planeja pedir mais do que apenas camisas? (Shorts, roupas de time, etc.)',
    orderMoreYes: 'Sim, precisaremos de mais do que apenas camisas.',
    orderMoreNo: 'Não, precisamos apenas de camisas.',

    // Contact Info
    firstName: 'Nome',
    lastName: 'Sobrenome',
    phoneNumber: 'Telefone',
    email: 'E-mail',

    // Add Others
    addOthersTitle: 'Deseja adicionar mais alguém ao projeto?',
    addOthersDesc: 'Colegas de equipe, treinadores, gerentes, etc. Membros podem ser adicionados a qualquer momento durante o projeto.',
    maybeLater: 'Talvez depois',

    // Delivery
    deliveryTitle: 'Quando você precisa receber seu equipamento personalizado?',
    deliveryDesc: 'Prazo atual (design + produção + envio): 4-6 semanas',

    // Country
    countryTitle: 'Para qual país enviaremos?',

    // Reversible
    reversibleTitle: 'Suas camisas precisam ser reversíveis?',
    reversibleDesc: 'Camisas reversíveis adicionarão $10 ao custo unitário.',
    reversibleYes: 'Sim, precisamos de camisas reversíveis.',
    reversibleNo: 'Não, um lado é suficiente.',

    // Team Info
    teamName: 'Nome do time/organização',
    yearFounded: 'Em que ano seu time/organização foi fundado?',

    // Colors
    primaryColor: 'Cor primária',
    primaryColorDesc: 'Esta cor será usada como cor base da camisa.',
    accentColor: 'Cor de destaque 1',
    accentColorDesc: 'Esta cor será usada para complementar a cor primária da camisa.',
    pickColor: 'Escolher uma cor',
    colorPrompt: 'Digite uma cor (ex: #ff0000, vermelho, etc.)',

    // Affiliation
    affiliationTitle: 'Qual é sua relação com o time/organização?',
    affiliationParent: 'Sou pai/mãe.',
    affiliationCoach: 'Sou treinador.',
    affiliationPlayer: 'Sou jogador.',
    affiliationOther: 'Outro',

    // File Upload
    uploadTitle: 'Envie arquivos de imagem que ajudarão a criar seu design',
    uploadDesc: 'Pode ser uma camisa real da qual você quer se inspirar, designs anteriores que seu time usou, ou imagens que nos ajudem a entender sua visão. Se você tem logos do time ou patrocinadores, envie-os também.',
    uploadNote: 'Se você tem arquivos não-imagem para enviar (arquivos do Illustrator, PDFs, etc.), por favor aguarde e envie-os depois no workspace JerseyBird do seu time.',
    chooseFile: 'Escolher arquivo',

    // First Project
    firstProjectTitle: 'Este é seu primeiro projeto conosco?',
    firstProjectYes: 'Sim, primeira vez!',
    firstProjectNo: 'Não, já estive aqui antes.',

    // How did you hear
    howDidYouHearTitle: 'Como você ouviu falar da JerseyBird?',
    googleSearch: 'Pesquisa Google',
    instagram: 'Instagram',
    facebook: 'Facebook',
    twitter: 'Twitter',
    youtube: 'Youtube',
    friendFamily: 'Um amigo/membro da família',
    sawTeam: 'Vi um time usando JerseyBird',
    tiktok: 'TikTok',

    // Submit
    submit: 'Enviar',
    formSuccess: 'Formulário enviado com sucesso!',

    // Soccer Options
    onFieldTitle: 'Monte um pacote em campo para seus jogadores.',
    onFieldDesc: 'Selecione os itens em campo que seu clube precisa.',
    offFieldTitle: 'Monte um pacote fora de campo para seus jogadores e staff.',
    offFieldDesc: 'Deixe em branco se nenhum item fora de campo for necessário.',
    
    homeShirt: 'Camisa titular',
    homeShorts: 'Shorts titular',
    homeSocks: 'Meias titular',
    awayShirt: 'Camisa reserva',
    awayShorts: 'Shorts reserva',
    awaySocks: 'Meias reserva',
    homeKeeperShirt: 'Camisa goleiro titular',
    homeKeeperShorts: 'Shorts goleiro titular',
    homeKeeperSocks: 'Meias goleiro titular',

    trainingJacket: 'Jaqueta de treino',
    trainingSweatpants: 'Calça de treino',
    playerCoachPolo: 'Polo jogador/treinador',
    hoodie: 'Moletom',
    shortSleeveTraining: 'Camisa treino manga curta',
    longSleeveTraining: 'Camisa treino manga longa',
    trainingBib: 'Colete de treino',
    winterPufferV1: 'Jaqueta puffer inverno V1',
    winterPufferV2: 'Jaqueta puffer inverno V2',

    collarStyleTitle: 'Selecione um estilo de gola:',
    crewneck: 'Gola careca',
    vNeck: 'Gola V',
    overlappingVNeck: 'Gola V sobreposta',
    polo: 'Polo',
    vNeckPolo: 'Polo gola V',

    sleeveStyleTitle: 'Selecione um estilo de manga.',
    sleeveStyleDesc: 'O estilo de manga não afeta o custo.',
    setInSleeves: 'Mangas convencionais',
    raglanSleeves: 'Mangas raglan',

    crestStyleTitle: 'Selecione um estilo de escudo do time',
    crestStyleDesc: 'Escudos sublimados são impressos na camisa. Escudos de silicone são mais grossos e de maior qualidade, tipicamente usados por clubes profissionais. Escudos de silicone têm quantidade mínima de pedido de 15.',
    sublimatedCrest: 'Escudo sublimado',
    siliconeCrest: 'Escudo de silicone',

    fitStyleTitle: 'Selecione um ajuste para suas camisas',
    fitStyleDesc: 'Um ajuste casual é mais relaxado com gola e punhos mais largos, enquanto o ajuste pro é mais ajustado ao corpo.',
    proFit: 'Ajuste Pro',
    casualFit: 'Ajuste Casual',

    fabricTypeTitle: 'Selecione um tecido para seu equipamento',
    fabricTypeDesc: 'Os tecidos BirdPro V1 e V2 são usados por clubes profissionais e seleções nacionais da JerseyBird.',
    standardFabric: 'Tecido padrão',
    birdproV1: 'Tecido BirdPro V1',
    birdproV2: 'Tecido BirdPro V2',

    collarCuffTitle: 'Selecione um estilo de tecido para gola e punhos',
    collarCuffDesc: 'O tecido rib knit adicionará $5 - $10 ao custo unitário.',
    ribKnitFabric: 'Tecido rib knit',

    templateTitle: 'Nossa equipe de design deve começar com um template?',
    templateDesc: 'Nome do clube, cores e detalhes adicionais podem ser enviados após a seleção do template.',
    noTemplate: 'Sem template, design totalmente personalizado.',
    zigZag: 'Zig Zag',
    abstractPaint: 'Pintura Abstrata',
    swirl: 'Espiral',
    wideStripes: 'Listras Largas',
    lineStripes: 'Listras Finas',
    brushStripes: 'Listras Pinceladas',
    jaggedStripes: 'Listras Irregulares',
    zebraStripes: 'Listras Zebra',

    // Language
    language: 'Idioma',

    // Basketball Options
    basketballOnFieldTitle: 'Monte um pacote em quadra para seus jogadores.',
    basketballOnFieldDesc: 'Selecione os itens em quadra que seu clube precisa.',
    basketballOffFieldTitle: 'Monte um pacote fora de quadra para seus jogadores e staff.',
    basketballOffFieldDesc: 'Deixe em branco se nenhum item fora de quadra for necessário.',
    basketballHomeJersey: 'Camisa titular',
    basketballHomeShorts: 'Shorts titular',
    basketballAwayJersey: 'Camisa reserva',
    basketballAwayShorts: 'Shorts reserva',
    basketballShootingShirt: 'Camisa de aquecimento',
    basketballWarmupJacket: 'Jaqueta de aquecimento',
    basketballWarmupPants: 'Calça de aquecimento',
    basketballTravelSuit: 'Conjunto de viagem',
    basketballJerseyStyleTitle: 'Selecione um estilo de camisa:',
    basketballTank: 'Regata',
    basketballSleeveless: 'Sem mangas',
    basketballShortSleeve: 'Manga curta',
    basketballNeckStyleTitle: 'Selecione um estilo de gola:',
    basketballRoundNeck: 'Gola redonda',
    basketballScoopNeck: 'Gola canoa',
    basketballFabricDesc: 'Os tecidos Pro Mesh e Elite são usados por equipes profissionais.',
    basketballProMesh: 'Tecido Pro Mesh',
    basketballElite: 'Tecido Elite',

    // Baseball Options
    baseballOnFieldTitle: 'Monte um pacote de campo para seus jogadores.',
    baseballOnFieldDesc: 'Selecione os itens de campo que seu time precisa.',
    baseballOffFieldTitle: 'Monte um pacote fora de campo para seus jogadores e staff.',
    baseballOffFieldDesc: 'Deixe em branco se nenhum item fora de campo for necessário.',
    baseballHomeJersey: 'Camisa titular',
    baseballAwayJersey: 'Camisa reserva',
    baseballPants: 'Calça',
    baseballBeltSocks: 'Cinto e meias',
    baseballCap: 'Boné',
    baseballWarmupJacket: 'Jaqueta de aquecimento',
    baseballPullover: 'Pullover',
    baseballJerseyStyleTitle: 'Selecione um estilo de camisa:',
    baseballFullButton: 'Botões completos',
    baseballTwoButton: 'Dois botões',
    baseballPulloverJersey: 'Pullover',
    baseballPantStyleTitle: 'Selecione um estilo de calça:',
    baseballFullLength: 'Comprimento total',
    baseballKnicker: 'Knicker',
    baseballFabricDesc: 'Os tecidos Pro Twill e Elite são usados por equipes profissionais.',
    baseballProTwill: 'Tecido Pro Twill',
    baseballElite: 'Tecido Elite',

    // Hockey Options
    hockeyOnFieldTitle: 'Monte um pacote de gelo para seus jogadores.',
    hockeyOnFieldDesc: 'Selecione os itens de gelo que seu clube precisa.',
    hockeyOffFieldTitle: 'Monte um pacote fora de gelo para seus jogadores e staff.',
    hockeyOffFieldDesc: 'Deixe em branco se nenhum item fora de gelo for necessário.',
    hockeyHomeJersey: 'Camisa titular',
    hockeyAwayJersey: 'Camisa reserva',
    hockeySocks: 'Meias',
    hockeyPracticeJersey: 'Camisa de treino',
    hockeyWarmupJacket: 'Jaqueta de aquecimento',
    hockeyTrackPants: 'Calça de treino',
    hockeyTravelSuit: 'Conjunto de viagem',
    hockeyJerseyStyleTitle: 'Selecione um estilo de camisa:',
    hockeyGameJersey: 'Camisa de jogo',
    hockeyPractice: 'Treino',
    hockeyFanJersey: 'Camisa de torcedor',
    hockeyCollarStyleTitle: 'Selecione um estilo de gola:',
    hockeyTraditionalCollar: 'Tradicional',
    hockeyModernCollar: 'Moderno',
    hockeyLaceUp: 'Com cadarço',
    hockeyFabricDesc: 'Os tecidos Air Knit e Pro Weight são usados por equipes profissionais.',
    hockeyAirKnit: 'Tecido Air Knit',
    hockeyProWeight: 'Tecido Pro Weight',

    // Football Options
    footballOnFieldTitle: 'Monte um pacote de campo para seus jogadores.',
    footballOnFieldDesc: 'Selecione os itens de campo que seu time precisa.',
    footballOffFieldTitle: 'Monte um pacote fora de campo para seus jogadores e staff.',
    footballOffFieldDesc: 'Deixe em branco se nenhum item fora de campo for necessário.',
    footballHomeJersey: 'Camisa titular',
    footballAwayJersey: 'Camisa reserva',
    footballPants: 'Calça',
    footballPracticeJersey: 'Camisa de treino',
    footballWarmupJacket: 'Jaqueta de aquecimento',
    footballSideline: 'Sideline',
    footballTravelSuit: 'Conjunto de viagem',
    footballJerseyStyleTitle: 'Selecione um estilo de camisa:',
    footballGameJersey: 'Camisa de jogo',
    footballPractice: 'Treino',
    footballCompression: 'Compressão',
    footballCollarStyleTitle: 'Selecione um estilo de gola:',
    footballFabricDesc: 'Os tecidos Speed Mesh e Pro Elite são usados por equipes profissionais.',
    footballSpeedMesh: 'Tecido Speed Mesh',
    footballProElite: 'Tecido Pro Elite',

    // Lacrosse Options
    lacrosseOnFieldTitle: 'Monte um pacote de campo para seus jogadores.',
    lacrosseOnFieldDesc: 'Selecione os itens de campo que seu time precisa.',
    lacrosseOffFieldTitle: 'Monte um pacote fora de campo para seus jogadores e staff.',
    lacrosseOffFieldDesc: 'Deixe em branco se nenhum item fora de campo for necessário.',
    lacrosseHomeJersey: 'Camisa titular',
    lacrosseAwayJersey: 'Camisa reserva',
    lacrosseShorts: 'Shorts',
    lacrossePinnies: 'Coletes',
    lacrosseWarmupJacket: 'Jaqueta de aquecimento',
    lacrosseShooter: 'Camisa shooter',
    lacrosseJerseyStyleTitle: 'Selecione um estilo de camisa:',
    lacrosseTraditional: 'Tradicional',
    lacrosseCompression: 'Compressão',
    lacrosseLoose: 'Solta',
    lacrosseSleeveStyleTitle: 'Selecione um estilo de manga:',
    lacrosseShortSleeve: 'Manga curta',
    lacrosseLongSleeve: 'Manga longa',
    lacrosseSleeveless: 'Sem mangas',
    lacrosseFabricDesc: 'Os tecidos Pro Mesh e Elite são usados por equipes profissionais.',
    lacrosseProMesh: 'Tecido Pro Mesh',
    lacrosseElite: 'Tecido Elite',

    // Rugby Options
    rugbyOnFieldTitle: 'Monte um pacote de campo para seus jogadores.',
    rugbyOnFieldDesc: 'Selecione os itens de campo que seu clube precisa.',
    rugbyOffFieldTitle: 'Monte um pacote fora de campo para seus jogadores e staff.',
    rugbyOffFieldDesc: 'Deixe em branco se nenhum item fora de campo for necessário.',
    rugbyHomeJersey: 'Camisa titular',
    rugbyAwayJersey: 'Camisa reserva',
    rugbyShorts: 'Shorts',
    rugbySocks: 'Meias',
    rugbyTrainingJersey: 'Camisa de treino',
    rugbyTracksuit: 'Agasalho',
    rugbyJerseyStyleTitle: 'Selecione um estilo de camisa:',
    rugbyTraditionalJersey: 'Tradicional',
    rugbyFittedJersey: 'Ajustada',
    rugbyLooseJersey: 'Solta',
    rugbyCollarStyleTitle: 'Selecione um estilo de gola:',
    rugbyTraditionalCollar: 'Tradicional',
    rugbyModernCollar: 'Moderno',
    rugbyGrandadCollar: 'Grandad',
    rugbyFabricDesc: 'Os tecidos Pro Cotton e Elite Poly são usados por equipes profissionais.',
    rugbyProCotton: 'Tecido Pro Cotton',
    rugbyElitePoly: 'Tecido Elite Poly',

    // Track Options
    trackOnFieldTitle: 'Monte um pacote de competição para seus atletas.',
    trackOnFieldDesc: 'Selecione os itens de competição que seu time precisa.',
    trackOffFieldTitle: 'Monte um pacote de aquecimento para seus atletas e staff.',
    trackOffFieldDesc: 'Deixe em branco se nenhum item de aquecimento for necessário.',
    trackSinglet: 'Regata',
    trackShorts: 'Shorts',
    trackTights: 'Leggings',
    trackWarmupTop: 'Top de aquecimento',
    trackWarmupPants: 'Calça de aquecimento',
    trackTeamJacket: 'Jaqueta do time',
    trackTracksuit: 'Agasalho',
    trackSingletStyleTitle: 'Selecione um estilo de regata:',
    trackRacerback: 'Racerback',
    trackTraditionalSinglet: 'Tradicional',
    trackCompressionSinglet: 'Compressão',
    trackShortsStyleTitle: 'Selecione um estilo de shorts:',
    trackSplitShorts: 'Split',
    trackVNotchShorts: 'V-Notch',
    trackCompressionShorts: 'Compressão',
    trackFabricDesc: 'Os tecidos Lightweight e Elite são usados por atletas profissionais.',
    trackLightweight: 'Tecido Leve',
    trackElite: 'Tecido Elite',
  },
  'en': {
    // Header
    startProject: 'Start a Project',
    aboutUs: 'About Us',
    findYourSport: 'Find Your Sport',
    shop: 'Shop',
    country: 'Brazil (USD $)',

    // Form Header - New commercial style
    title: 'Simulate Your Uniform',
    subtitle: 'Get a cost estimate in less than 2 minutes',
    desc1: 'Fill out the form and receive a personalized proposal.',
    desc2: 'Minimum order:',
    desc2Bold: '10 pieces',
    desc3: 'Delivery nationwide.',
    
    // Real-time estimate
    estimateTitle: 'Your Estimate',
    estimateRange: 'Estimated value',
    estimateDelivery: 'Estimated delivery',
    estimateDiscount: 'Quantity discount',
    estimateTip: 'Above 30 pieces you save up to 10%',
    estimateWeeks: 'weeks',
    estimateDays: 'days',
    estimateFrom: 'from',
    
    // Customer profile
    customerProfileTitle: 'What is your profile?',
    customerProfileDesc: 'This helps us personalize your proposal.',
    profileTeam: 'Team/Club',
    profileTeamDesc: 'Uniform for sports team',
    profileCompany: 'Company',
    profileCompanyDesc: 'Corporate or promotional uniform',
    profileEvent: 'Event',
    profileEventDesc: 'Uniform for specific event',
    profileReseller: 'Reseller',
    profileResellerDesc: 'Purchase to resell',
    
    // Quantity with commercial intelligence
    quantityTitle: 'How many pieces do you need?',
    quantityDesc: 'Select the estimated quantity.',
    quantityTip10: 'Minimum order',
    quantityTip30: 'Best value',
    quantityTip50: '15% discount',
    quantityTip100: '20% discount - Wholesale',
    quantityWarning: 'Minimum order of 10 pieces',
    
    // Personalization
    personalizationTitle: 'Personalization',
    personalizationDesc: 'What will your uniform have?',
    hasNameNumber: 'Name and number on back?',
    hasNameNumberYes: 'Yes, each piece will have name/number',
    hasNameNumberNo: 'No, standard uniform',
    hasCustomDesign: 'Custom design?',
    hasCustomDesignYes: 'Yes, I want an exclusive design',
    hasCustomDesignNo: 'No, I can use templates',
    
    // Urgency
    urgencyTitle: 'How urgent is it?',
    urgencyDesc: 'The deadline affects the final price.',
    urgencyNormal: 'Normal',
    urgencyNormalDesc: '4-6 weeks',
    urgencyUrgent: 'Urgent',
    urgencyUrgentDesc: '2-3 weeks (+25%)',
    
    // Location/Delivery
    cityLabel: 'City',
    deliveryMethodTitle: 'How do you prefer to receive?',
    deliveryPickup: 'Pick up at location',
    deliveryDelivery: 'Deliver to address',
    
    // Contact
    contactTitle: 'Your contact information',
    contactDesc: 'We will contact you to finalize your proposal.',
    companyNameLabel: 'Company name (optional)',
    whatsappLabel: 'WhatsApp',
    
    // Result/Final estimate
    resultTitle: 'Your Estimate',
    resultSubtitle: 'Based on your selections',
    resultPrice: 'Estimated value',
    resultDelivery: 'Delivery time',
    resultRecommendation: 'Recommendation',
    resultCTA: 'Receive Full Proposal',
    resultNote: 'This is an estimate. The final value may vary.',
    
    // Value triggers
    valueQuality: 'Professional quality',
    valueDelivery: 'Guaranteed delivery',
    valueDifferential: 'Exclusive design',

    // Featured on Social
    featuredTitle: 'Would you like your project to be featured on JerseyBird social media channels?',
    learnMore: 'Learn more',
    yes: 'Yes',
    no: 'No',

    // Sport Selection
    selectSport: 'Select your sport',
    soccer: 'Soccer',
    basketball: 'Basketball',
    baseball: 'Baseball',
    hockey: 'Hockey',
    football: 'Football',
    lacrosse: 'Lacrosse',
    rugby: 'Rugby',
    track: 'Track',
    other: 'Other',

    // Program Selection
    selectProgram: 'Select your program',
    programDescription: 'Pick the program that fits your timeline and design needs. Total lead time includes design, production, and shipping.',
    standardTitle: 'JerseyBird Standard (Full control, fully custom kits)',
    standardFeature1: 'Fully customized designs',
    standardFeature2: 'Upgrade options available',
    standardFeature3: '6-8 week total lead time',
    speedrunTitle: 'JerseyBird SpeedRun (Faster turnaround, limited design options)',
    speedrunFeature1: 'Template based designs',
    speedrunFeature2: 'Full sublimation, limited upgrades',
    speedrunFeature3: '4-5 week total lead time',

    // Athletes
    estimatedAthletes: 'Estimated number of athletes in your program/team',
    selectPlaceholder: 'Select...',

    // More than jerseys
    orderMoreTitle: 'Do you plan on ordering more than just jerseys? (Shorts, team apparel, etc.)',
    orderMoreYes: 'Yes, we\'ll need more than just jerseys.',
    orderMoreNo: 'No, we only need jerseys.',

    // Contact Info
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    email: 'Email',

    // Add Others
    addOthersTitle: 'Do you want to add anyone else to the project?',
    addOthersDesc: 'Teammates, coaches, managers, etc. Members can be added at any time during a project.',
    maybeLater: 'Maybe later',

    // Delivery
    deliveryTitle: 'When do you need to receive your custom equipment?',
    deliveryDesc: 'Current lead time (design + production + shipping): 4-6 weeks',

    // Country
    countryTitle: 'What country will we be shipping to?',

    // Reversible
    reversibleTitle: 'Will your jerseys need to be reversible?',
    reversibleDesc: 'Reversible jerseys will add $10 to your unit cost.',
    reversibleYes: 'Yes, we need reversible jerseys.',
    reversibleNo: 'No, one sided is fine.',

    // Team Info
    teamName: 'Team/organization name',
    yearFounded: 'What year was your team/organization founded?',

    // Colors
    primaryColor: 'Primary color',
    primaryColorDesc: 'This color will be used as the base color for the jersey.',
    accentColor: 'Accent color 1',
    accentColorDesc: 'This color will be used to complement the primary jersey color.',
    pickColor: 'Pick a color',
    colorPrompt: 'Enter a color (e.g.: #ff0000, red, etc.)',

    // Affiliation
    affiliationTitle: 'What is your affiliation with the team/organization?',
    affiliationParent: 'I am a parent.',
    affiliationCoach: 'I am a coach.',
    affiliationPlayer: 'I am a player.',
    affiliationOther: 'Other',

    // File Upload
    uploadTitle: 'Upload any image file(s) that will help us create your design',
    uploadDesc: 'This can be a real-world jersey you want to take inspiration from, past designs your team has worn, or images that help us understand your vision. If you have team or sponsor logos, upload them as well.',
    uploadNote: 'If you have non-image files to upload (Illustrator files, PDFs, etc.), please wait and upload them later in your team\'s JerseyBird workspace.',
    chooseFile: 'Choose a file',

    // First Project
    firstProjectTitle: 'Is this your first project with us?',
    firstProjectYes: 'Yes, first time!',
    firstProjectNo: 'Nope, I\'ve been here before.',

    // How did you hear
    howDidYouHearTitle: 'How did you hear about JerseyBird?',
    googleSearch: 'Google search',
    instagram: 'Instagram',
    facebook: 'Facebook',
    twitter: 'Twitter',
    youtube: 'Youtube',
    friendFamily: 'A friend/family member',
    sawTeam: 'I saw a team wearing JerseyBird',
    tiktok: 'TikTok',

    // Submit
    submit: 'Submit',
    formSuccess: 'Form submitted successfully!',

    // Soccer Options
    onFieldTitle: 'Build an on-field package for your players.',
    onFieldDesc: 'Select the on-field items your club requires.',
    offFieldTitle: 'Build an off-field package for your players and staff.',
    offFieldDesc: 'Leave blank if no off-field items are required.',
    
    homeShirt: 'Home shirt',
    homeShorts: 'Home shorts',
    homeSocks: 'Home socks',
    awayShirt: 'Away shirt',
    awayShorts: 'Away shorts',
    awaySocks: 'Away socks',
    homeKeeperShirt: 'Home keeper shirt',
    homeKeeperShorts: 'Home keeper shorts',
    homeKeeperSocks: 'Home keeper socks',

    trainingJacket: 'Training jacket',
    trainingSweatpants: 'Training sweatpants',
    playerCoachPolo: 'Player/coach polo',
    hoodie: 'Hoodie',
    shortSleeveTraining: 'Short sleeve pre-match/training shirt',
    longSleeveTraining: 'Long sleeve pre-match/training shirt',
    trainingBib: 'Training bib',
    winterPufferV1: 'Winter puffer jacket V1',
    winterPufferV2: 'Winter puffer jacket V2',

    collarStyleTitle: 'Select a collar style:',
    crewneck: 'Crewneck',
    vNeck: 'V-Neck',
    overlappingVNeck: 'Overlapping V-Neck',
    polo: 'Polo',
    vNeckPolo: 'V-Neck Polo',

    sleeveStyleTitle: 'Select a sleeve style.',
    sleeveStyleDesc: 'Sleeve style does not affect cost.',
    setInSleeves: 'Set-in sleeves',
    raglanSleeves: 'Raglan sleeves',

    crestStyleTitle: 'Select a team crest style',
    crestStyleDesc: 'Sublimation crests are printed onto the shirt. Silicone crests are a thicker, higher quality crest typically used by professional clubs. Silicone crests have a minimum order quantity of 15.',
    sublimatedCrest: 'Sublimated crest',
    siliconeCrest: 'Silicone crest',

    fitStyleTitle: 'Select a fit for your jerseys',
    fitStyleDesc: 'A casual fit is more relaxed with a wider collar and sleeve cuffs while a pro fit is more fitted to the body.',
    proFit: 'Pro fit',
    casualFit: 'Casual fit',

    fabricTypeTitle: 'Select a fabric for your equipment',
    fabricTypeDesc: 'BirdPro V1 & V2 fabrics are used for JerseyBird professional clubs and national teams.',
    standardFabric: 'Standard fabric',
    birdproV1: 'BirdPro V1 fabric',
    birdproV2: 'BirdPro V2 fabric',

    collarCuffTitle: 'Select a collar & cuff fabric style',
    collarCuffDesc: 'Rib knit fabric will add $5 - $10 to your unit cost.',
    ribKnitFabric: 'Rib knit fabric',

    templateTitle: 'Should our design team start with template?',
    templateDesc: 'Club name, colors, and additional details can be submitted once a template is selected.',
    noTemplate: 'No template, full custom design.',
    zigZag: 'Zig Zag',
    abstractPaint: 'Abstract Paint',
    swirl: 'Swirl',
    wideStripes: 'Wide Stripes',
    lineStripes: 'Line Stripes',
    brushStripes: 'Brush Stripes',
    jaggedStripes: 'Jagged Stripes',
    zebraStripes: 'Zebra Stripes',

    // Language
    language: 'Language',

    // Basketball Options
    basketballOnFieldTitle: 'Build an on-court package for your players.',
    basketballOnFieldDesc: 'Select the on-court items your club requires.',
    basketballOffFieldTitle: 'Build an off-court package for your players and staff.',
    basketballOffFieldDesc: 'Leave blank if no off-court items are required.',
    basketballHomeJersey: 'Home jersey',
    basketballHomeShorts: 'Home shorts',
    basketballAwayJersey: 'Away jersey',
    basketballAwayShorts: 'Away shorts',
    basketballShootingShirt: 'Shooting shirt',
    basketballWarmupJacket: 'Warmup jacket',
    basketballWarmupPants: 'Warmup pants',
    basketballTravelSuit: 'Travel suit',
    basketballJerseyStyleTitle: 'Select a jersey style:',
    basketballTank: 'Tank',
    basketballSleeveless: 'Sleeveless',
    basketballShortSleeve: 'Short sleeve',
    basketballNeckStyleTitle: 'Select a neck style:',
    basketballRoundNeck: 'Round neck',
    basketballScoopNeck: 'Scoop neck',
    basketballFabricDesc: 'Pro Mesh and Elite fabrics are used by professional teams.',
    basketballProMesh: 'Pro Mesh fabric',
    basketballElite: 'Elite fabric',

    // Baseball Options
    baseballOnFieldTitle: 'Build an on-field package for your players.',
    baseballOnFieldDesc: 'Select the on-field items your team requires.',
    baseballOffFieldTitle: 'Build an off-field package for your players and staff.',
    baseballOffFieldDesc: 'Leave blank if no off-field items are required.',
    baseballHomeJersey: 'Home jersey',
    baseballAwayJersey: 'Away jersey',
    baseballPants: 'Pants',
    baseballBeltSocks: 'Belt & socks',
    baseballCap: 'Cap',
    baseballWarmupJacket: 'Warmup jacket',
    baseballPullover: 'Pullover',
    baseballJerseyStyleTitle: 'Select a jersey style:',
    baseballFullButton: 'Full button',
    baseballTwoButton: 'Two button',
    baseballPulloverJersey: 'Pullover',
    baseballPantStyleTitle: 'Select a pant style:',
    baseballFullLength: 'Full length',
    baseballKnicker: 'Knicker',
    baseballFabricDesc: 'Pro Twill and Elite fabrics are used by professional teams.',
    baseballProTwill: 'Pro Twill fabric',
    baseballElite: 'Elite fabric',

    // Hockey Options
    hockeyOnFieldTitle: 'Build an on-ice package for your players.',
    hockeyOnFieldDesc: 'Select the on-ice items your club requires.',
    hockeyOffFieldTitle: 'Build an off-ice package for your players and staff.',
    hockeyOffFieldDesc: 'Leave blank if no off-ice items are required.',
    hockeyHomeJersey: 'Home jersey',
    hockeyAwayJersey: 'Away jersey',
    hockeySocks: 'Socks',
    hockeyPracticeJersey: 'Practice jersey',
    hockeyWarmupJacket: 'Warmup jacket',
    hockeyTrackPants: 'Track pants',
    hockeyTravelSuit: 'Travel suit',
    hockeyJerseyStyleTitle: 'Select a jersey style:',
    hockeyGameJersey: 'Game jersey',
    hockeyPractice: 'Practice',
    hockeyFanJersey: 'Fan jersey',
    hockeyCollarStyleTitle: 'Select a collar style:',
    hockeyTraditionalCollar: 'Traditional',
    hockeyModernCollar: 'Modern',
    hockeyLaceUp: 'Lace-up',
    hockeyFabricDesc: 'Air Knit and Pro Weight fabrics are used by professional teams.',
    hockeyAirKnit: 'Air Knit fabric',
    hockeyProWeight: 'Pro Weight fabric',

    // Football Options
    footballOnFieldTitle: 'Build an on-field package for your players.',
    footballOnFieldDesc: 'Select the on-field items your team requires.',
    footballOffFieldTitle: 'Build an off-field package for your players and staff.',
    footballOffFieldDesc: 'Leave blank if no off-field items are required.',
    footballHomeJersey: 'Home jersey',
    footballAwayJersey: 'Away jersey',
    footballPants: 'Pants',
    footballPracticeJersey: 'Practice jersey',
    footballWarmupJacket: 'Warmup jacket',
    footballSideline: 'Sideline gear',
    footballTravelSuit: 'Travel suit',
    footballJerseyStyleTitle: 'Select a jersey style:',
    footballGameJersey: 'Game jersey',
    footballPractice: 'Practice',
    footballCompression: 'Compression',
    footballCollarStyleTitle: 'Select a collar style:',
    footballFabricDesc: 'Speed Mesh and Pro Elite fabrics are used by professional teams.',
    footballSpeedMesh: 'Speed Mesh fabric',
    footballProElite: 'Pro Elite fabric',

    // Lacrosse Options
    lacrosseOnFieldTitle: 'Build an on-field package for your players.',
    lacrosseOnFieldDesc: 'Select the on-field items your team requires.',
    lacrosseOffFieldTitle: 'Build an off-field package for your players and staff.',
    lacrosseOffFieldDesc: 'Leave blank if no off-field items are required.',
    lacrosseHomeJersey: 'Home jersey',
    lacrosseAwayJersey: 'Away jersey',
    lacrosseShorts: 'Shorts',
    lacrossePinnies: 'Pinnies',
    lacrosseWarmupJacket: 'Warmup jacket',
    lacrosseShooter: 'Shooter shirt',
    lacrosseJerseyStyleTitle: 'Select a jersey style:',
    lacrosseTraditional: 'Traditional',
    lacrosseCompression: 'Compression',
    lacrosseLoose: 'Loose',
    lacrosseSleeveStyleTitle: 'Select a sleeve style:',
    lacrosseShortSleeve: 'Short sleeve',
    lacrosseLongSleeve: 'Long sleeve',
    lacrosseSleeveless: 'Sleeveless',
    lacrosseFabricDesc: 'Pro Mesh and Elite fabrics are used by professional teams.',
    lacrosseProMesh: 'Pro Mesh fabric',
    lacrosseElite: 'Elite fabric',

    // Rugby Options
    rugbyOnFieldTitle: 'Build an on-field package for your players.',
    rugbyOnFieldDesc: 'Select the on-field items your club requires.',
    rugbyOffFieldTitle: 'Build an off-field package for your players and staff.',
    rugbyOffFieldDesc: 'Leave blank if no off-field items are required.',
    rugbyHomeJersey: 'Home jersey',
    rugbyAwayJersey: 'Away jersey',
    rugbyShorts: 'Shorts',
    rugbySocks: 'Socks',
    rugbyTrainingJersey: 'Training jersey',
    rugbyTracksuit: 'Tracksuit',
    rugbyJerseyStyleTitle: 'Select a jersey style:',
    rugbyTraditionalJersey: 'Traditional',
    rugbyFittedJersey: 'Fitted',
    rugbyLooseJersey: 'Loose',
    rugbyCollarStyleTitle: 'Select a collar style:',
    rugbyTraditionalCollar: 'Traditional',
    rugbyModernCollar: 'Modern',
    rugbyGrandadCollar: 'Grandad',
    rugbyFabricDesc: 'Pro Cotton and Elite Poly fabrics are used by professional teams.',
    rugbyProCotton: 'Pro Cotton fabric',
    rugbyElitePoly: 'Elite Poly fabric',

    // Track Options
    trackOnFieldTitle: 'Build a competition package for your athletes.',
    trackOnFieldDesc: 'Select the competition items your team requires.',
    trackOffFieldTitle: 'Build a warmup package for your athletes and staff.',
    trackOffFieldDesc: 'Leave blank if no warmup items are required.',
    trackSinglet: 'Singlet',
    trackShorts: 'Shorts',
    trackTights: 'Tights',
    trackWarmupTop: 'Warmup top',
    trackWarmupPants: 'Warmup pants',
    trackTeamJacket: 'Team jacket',
    trackTracksuit: 'Tracksuit',
    trackSingletStyleTitle: 'Select a singlet style:',
    trackRacerback: 'Racerback',
    trackTraditionalSinglet: 'Traditional',
    trackCompressionSinglet: 'Compression',
    trackShortsStyleTitle: 'Select a shorts style:',
    trackSplitShorts: 'Split',
    trackVNotchShorts: 'V-Notch',
    trackCompressionShorts: 'Compression',
    trackFabricDesc: 'Lightweight and Elite fabrics are used by professional athletes.',
    trackLightweight: 'Lightweight fabric',
    trackElite: 'Elite fabric',
  },
  'es': {
    // Header
    startProject: 'Iniciar Proyecto',
    aboutUs: 'Sobre Nosotros',
    findYourSport: 'Encuentra tu Deporte',
    shop: 'Tienda',
    country: 'Brasil (USD $)',

    // Form Header - Nuevo estilo comercial
    title: 'Simule su Uniforme',
    subtitle: 'Obtenga una estimación de costo en menos de 2 minutos',
    desc1: 'Complete el formulario y reciba una propuesta personalizada.',
    desc2: 'Pedido mínimo:',
    desc2Bold: '10 piezas',
    desc3: 'Entrega en todo el país.',
    
    // Estimación en tiempo real
    estimateTitle: 'Su Estimación',
    estimateRange: 'Valor estimado',
    estimateDelivery: 'Entrega estimada',
    estimateDiscount: 'Descuento por cantidad',
    estimateTip: 'Más de 30 piezas ahorra hasta 10%',
    estimateWeeks: 'semanas',
    estimateDays: 'días',
    estimateFrom: 'desde',
    
    // Perfil del cliente
    customerProfileTitle: '¿Cuál es su perfil?',
    customerProfileDesc: 'Esto nos ayuda a personalizar su propuesta.',
    profileTeam: 'Equipo/Club',
    profileTeamDesc: 'Uniforme para equipo deportivo',
    profileCompany: 'Empresa',
    profileCompanyDesc: 'Uniforme corporativo o promocional',
    profileEvent: 'Evento',
    profileEventDesc: 'Uniforme para evento específico',
    profileReseller: 'Reventa',
    profileResellerDesc: 'Compra para revender',
    
    // Cantidad con inteligencia comercial
    quantityTitle: '¿Cuántas piezas necesita?',
    quantityDesc: 'Seleccione la cantidad estimada.',
    quantityTip10: 'Pedido mínimo',
    quantityTip30: 'Mejor costo-beneficio',
    quantityTip50: '15% de descuento',
    quantityTip100: '20% de descuento - Mayorista',
    quantityWarning: 'Pedido mínimo de 10 piezas',
    
    // Personalización
    personalizationTitle: 'Personalización',
    personalizationDesc: '¿Qué tendrá su uniforme?',
    hasNameNumber: '¿Nombre y número en la espalda?',
    hasNameNumberYes: 'Sí, cada pieza tendrá nombre/número',
    hasNameNumberNo: 'No, uniforme estándar',
    hasCustomDesign: '¿Diseño personalizado?',
    hasCustomDesignYes: 'Sí, quiero un diseño exclusivo',
    hasCustomDesignNo: 'No, puedo usar plantillas',
    
    // Urgencia
    urgencyTitle: '¿Cuál es la urgencia?',
    urgencyDesc: 'El plazo afecta el precio final.',
    urgencyNormal: 'Normal',
    urgencyNormalDesc: '4-6 semanas',
    urgencyUrgent: 'Urgente',
    urgencyUrgentDesc: '2-3 semanas (+25%)',
    
    // Ubicación/Entrega
    cityLabel: 'Ciudad',
    deliveryMethodTitle: '¿Cómo prefiere recibir?',
    deliveryPickup: 'Recoger en el local',
    deliveryDelivery: 'Entregar en la dirección',
    
    // Contacto
    contactTitle: 'Sus datos de contacto',
    contactDesc: 'Nos pondremos en contacto para finalizar su propuesta.',
    companyNameLabel: 'Nombre de la empresa (opcional)',
    whatsappLabel: 'WhatsApp',
    
    // Resultado/Estimación final
    resultTitle: 'Su Estimación',
    resultSubtitle: 'Basado en sus selecciones',
    resultPrice: 'Valor estimado',
    resultDelivery: 'Tiempo de entrega',
    resultRecommendation: 'Recomendación',
    resultCTA: 'Recibir Propuesta Completa',
    resultNote: 'Esta es una estimación. El valor final puede variar.',
    
    // Gatillos de valor
    valueQuality: 'Calidad profesional',
    valueDelivery: 'Entrega garantizada',
    valueDifferential: 'Diseño exclusivo',

    // Featured on Social
    featuredTitle: '¿Le gustaría que su proyecto aparezca en los canales de redes sociales de JerseyBird?',
    learnMore: 'Más información',
    yes: 'Sí',
    no: 'No',

    // Sport Selection
    selectSport: 'Seleccione su deporte',
    soccer: 'Fútbol',
    basketball: 'Baloncesto',
    baseball: 'Béisbol',
    hockey: 'Hockey',
    football: 'Fútbol Americano',
    lacrosse: 'Lacrosse',
    rugby: 'Rugby',
    track: 'Atletismo',
    other: 'Otro',

    // Program Selection
    selectProgram: 'Seleccione su programa',
    programDescription: 'Elija el programa que se adapte a su cronograma y necesidades de diseño. El tiempo total incluye diseño, producción y envío.',
    standardTitle: 'JerseyBird Standard (Control total, kits completamente personalizados)',
    standardFeature1: 'Diseños completamente personalizados',
    standardFeature2: 'Opciones de actualización disponibles',
    standardFeature3: '6-8 semanas de tiempo total',
    speedrunTitle: 'JerseyBird SpeedRun (Entrega más rápida, opciones de diseño limitadas)',
    speedrunFeature1: 'Diseños basados en plantillas',
    speedrunFeature2: 'Sublimación completa, actualizaciones limitadas',
    speedrunFeature3: '4-5 semanas de tiempo total',

    // Athletes
    estimatedAthletes: 'Número estimado de atletas en su programa/equipo',
    selectPlaceholder: 'Seleccione...',

    // More than jerseys
    orderMoreTitle: '¿Planea pedir más que solo camisetas? (Shorts, ropa de equipo, etc.)',
    orderMoreYes: 'Sí, necesitaremos más que solo camisetas.',
    orderMoreNo: 'No, solo necesitamos camisetas.',

    // Contact Info
    firstName: 'Nombre',
    lastName: 'Apellido',
    phoneNumber: 'Teléfono',
    email: 'Correo electrónico',

    // Add Others
    addOthersTitle: '¿Desea agregar a alguien más al proyecto?',
    addOthersDesc: 'Compañeros de equipo, entrenadores, gerentes, etc. Los miembros pueden ser agregados en cualquier momento durante el proyecto.',
    maybeLater: 'Quizás después',

    // Delivery
    deliveryTitle: '¿Cuándo necesita recibir su equipo personalizado?',
    deliveryDesc: 'Tiempo actual (diseño + producción + envío): 4-6 semanas',

    // Country
    countryTitle: '¿A qué país enviaremos?',

    // Reversible
    reversibleTitle: '¿Sus camisetas necesitan ser reversibles?',
    reversibleDesc: 'Las camisetas reversibles agregarán $10 al costo unitario.',
    reversibleYes: 'Sí, necesitamos camisetas reversibles.',
    reversibleNo: 'No, un solo lado está bien.',

    // Team Info
    teamName: 'Nombre del equipo/organización',
    yearFounded: '¿En qué año se fundó su equipo/organización?',

    // Colors
    primaryColor: 'Color primario',
    primaryColorDesc: 'Este color se usará como color base de la camiseta.',
    accentColor: 'Color de acento 1',
    accentColorDesc: 'Este color se usará para complementar el color primario de la camiseta.',
    pickColor: 'Elegir un color',
    colorPrompt: 'Ingrese un color (ej: #ff0000, rojo, etc.)',

    // Affiliation
    affiliationTitle: '¿Cuál es su relación con el equipo/organización?',
    affiliationParent: 'Soy padre/madre.',
    affiliationCoach: 'Soy entrenador.',
    affiliationPlayer: 'Soy jugador.',
    affiliationOther: 'Otro',

    // File Upload
    uploadTitle: 'Suba archivos de imagen que ayuden a crear su diseño',
    uploadDesc: 'Puede ser una camiseta real de la que quiera inspirarse, diseños anteriores que su equipo haya usado, o imágenes que nos ayuden a entender su visión. Si tiene logos del equipo o patrocinadores, súbalos también.',
    uploadNote: 'Si tiene archivos que no son imágenes para subir (archivos de Illustrator, PDFs, etc.), espere y súbalos después en el espacio de trabajo JerseyBird de su equipo.',
    chooseFile: 'Elegir archivo',

    // First Project
    firstProjectTitle: '¿Es este su primer proyecto con nosotros?',
    firstProjectYes: '¡Sí, primera vez!',
    firstProjectNo: 'No, ya he estado aquí antes.',

    // How did you hear
    howDidYouHearTitle: '¿Cómo escuchó sobre JerseyBird?',
    googleSearch: 'Búsqueda en Google',
    instagram: 'Instagram',
    facebook: 'Facebook',
    twitter: 'Twitter',
    youtube: 'Youtube',
    friendFamily: 'Un amigo/familiar',
    sawTeam: 'Vi a un equipo usando JerseyBird',
    tiktok: 'TikTok',

    // Submit
    submit: 'Enviar',
    formSuccess: '¡Formulario enviado con éxito!',

    // Soccer Options
    onFieldTitle: 'Arme un paquete de campo para sus jugadores.',
    onFieldDesc: 'Seleccione los artículos de campo que su club requiere.',
    offFieldTitle: 'Arme un paquete fuera de campo para sus jugadores y personal.',
    offFieldDesc: 'Deje en blanco si no se requieren artículos fuera de campo.',
    
    homeShirt: 'Camiseta local',
    homeShorts: 'Shorts local',
    homeSocks: 'Medias local',
    awayShirt: 'Camiseta visitante',
    awayShorts: 'Shorts visitante',
    awaySocks: 'Medias visitante',
    homeKeeperShirt: 'Camiseta arquero local',
    homeKeeperShorts: 'Shorts arquero local',
    homeKeeperSocks: 'Medias arquero local',

    trainingJacket: 'Chaqueta de entrenamiento',
    trainingSweatpants: 'Pantalón de entrenamiento',
    playerCoachPolo: 'Polo jugador/entrenador',
    hoodie: 'Sudadera',
    shortSleeveTraining: 'Camiseta entrenamiento manga corta',
    longSleeveTraining: 'Camiseta entrenamiento manga larga',
    trainingBib: 'Peto de entrenamiento',
    winterPufferV1: 'Chaqueta puffer invierno V1',
    winterPufferV2: 'Chaqueta puffer invierno V2',

    collarStyleTitle: 'Seleccione un estilo de cuello:',
    crewneck: 'Cuello redondo',
    vNeck: 'Cuello V',
    overlappingVNeck: 'Cuello V superpuesto',
    polo: 'Polo',
    vNeckPolo: 'Polo cuello V',

    sleeveStyleTitle: 'Seleccione un estilo de manga.',
    sleeveStyleDesc: 'El estilo de manga no afecta el costo.',
    setInSleeves: 'Mangas convencionales',
    raglanSleeves: 'Mangas raglan',

    crestStyleTitle: 'Seleccione un estilo de escudo del equipo',
    crestStyleDesc: 'Los escudos sublimados se imprimen en la camiseta. Los escudos de silicona son más gruesos y de mayor calidad, típicamente usados por clubes profesionales. Los escudos de silicona tienen una cantidad mínima de pedido de 15.',
    sublimatedCrest: 'Escudo sublimado',
    siliconeCrest: 'Escudo de silicona',

    fitStyleTitle: 'Seleccione un ajuste para sus camisetas',
    fitStyleDesc: 'Un ajuste casual es más relajado con cuello y puños más anchos, mientras que el ajuste pro es más ajustado al cuerpo.',
    proFit: 'Ajuste Pro',
    casualFit: 'Ajuste Casual',

    fabricTypeTitle: 'Seleccione una tela para su equipo',
    fabricTypeDesc: 'Las telas BirdPro V1 y V2 son usadas por clubes profesionales y selecciones nacionales de JerseyBird.',
    standardFabric: 'Tela estándar',
    birdproV1: 'Tela BirdPro V1',
    birdproV2: 'Tela BirdPro V2',

    collarCuffTitle: 'Seleccione un estilo de tela para cuello y puños',
    collarCuffDesc: 'La tela rib knit agregará $5 - $10 al costo unitario.',
    ribKnitFabric: 'Tela rib knit',

    templateTitle: '¿Nuestro equipo de diseño debe comenzar con una plantilla?',
    templateDesc: 'Nombre del club, colores y detalles adicionales pueden ser enviados después de seleccionar la plantilla.',
    noTemplate: 'Sin plantilla, diseño completamente personalizado.',
    zigZag: 'Zig Zag',
    abstractPaint: 'Pintura Abstracta',
    swirl: 'Espiral',
    wideStripes: 'Rayas Anchas',
    lineStripes: 'Rayas Finas',
    brushStripes: 'Rayas Pinceladas',
    jaggedStripes: 'Rayas Irregulares',
    zebraStripes: 'Rayas Cebra',

    // Language
    language: 'Idioma',

    // Basketball Options
    basketballOnFieldTitle: 'Arme un paquete de cancha para sus jugadores.',
    basketballOnFieldDesc: 'Seleccione los artículos de cancha que su club requiere.',
    basketballOffFieldTitle: 'Arme un paquete fuera de cancha para sus jugadores y personal.',
    basketballOffFieldDesc: 'Deje en blanco si no se requieren artículos fuera de cancha.',
    basketballHomeJersey: 'Camiseta local',
    basketballHomeShorts: 'Shorts local',
    basketballAwayJersey: 'Camiseta visitante',
    basketballAwayShorts: 'Shorts visitante',
    basketballShootingShirt: 'Camiseta de calentamiento',
    basketballWarmupJacket: 'Chaqueta de calentamiento',
    basketballWarmupPants: 'Pantalón de calentamiento',
    basketballTravelSuit: 'Conjunto de viaje',
    basketballJerseyStyleTitle: 'Seleccione un estilo de camiseta:',
    basketballTank: 'Musculosa',
    basketballSleeveless: 'Sin mangas',
    basketballShortSleeve: 'Manga corta',
    basketballNeckStyleTitle: 'Seleccione un estilo de cuello:',
    basketballRoundNeck: 'Cuello redondo',
    basketballScoopNeck: 'Cuello bote',
    basketballFabricDesc: 'Las telas Pro Mesh y Elite son usadas por equipos profesionales.',
    basketballProMesh: 'Tela Pro Mesh',
    basketballElite: 'Tela Elite',

    // Baseball Options
    baseballOnFieldTitle: 'Arme un paquete de campo para sus jugadores.',
    baseballOnFieldDesc: 'Seleccione los artículos de campo que su equipo requiere.',
    baseballOffFieldTitle: 'Arme un paquete fuera de campo para sus jugadores y personal.',
    baseballOffFieldDesc: 'Deje en blanco si no se requieren artículos fuera de campo.',
    baseballHomeJersey: 'Camiseta local',
    baseballAwayJersey: 'Camiseta visitante',
    baseballPants: 'Pantalón',
    baseballBeltSocks: 'Cinturón y medias',
    baseballCap: 'Gorra',
    baseballWarmupJacket: 'Chaqueta de calentamiento',
    baseballPullover: 'Pullover',
    baseballJerseyStyleTitle: 'Seleccione un estilo de camiseta:',
    baseballFullButton: 'Botones completos',
    baseballTwoButton: 'Dos botones',
    baseballPulloverJersey: 'Pullover',
    baseballPantStyleTitle: 'Seleccione un estilo de pantalón:',
    baseballFullLength: 'Largo completo',
    baseballKnicker: 'Knicker',
    baseballFabricDesc: 'Las telas Pro Twill y Elite son usadas por equipos profesionales.',
    baseballProTwill: 'Tela Pro Twill',
    baseballElite: 'Tela Elite',

    // Hockey Options
    hockeyOnFieldTitle: 'Arme un paquete de hielo para sus jugadores.',
    hockeyOnFieldDesc: 'Seleccione los artículos de hielo que su club requiere.',
    hockeyOffFieldTitle: 'Arme un paquete fuera de hielo para sus jugadores y personal.',
    hockeyOffFieldDesc: 'Deje en blanco si no se requieren artículos fuera de hielo.',
    hockeyHomeJersey: 'Camiseta local',
    hockeyAwayJersey: 'Camiseta visitante',
    hockeySocks: 'Medias',
    hockeyPracticeJersey: 'Camiseta de práctica',
    hockeyWarmupJacket: 'Chaqueta de calentamiento',
    hockeyTrackPants: 'Pantalón de entrenamiento',
    hockeyTravelSuit: 'Conjunto de viaje',
    hockeyJerseyStyleTitle: 'Seleccione un estilo de camiseta:',
    hockeyGameJersey: 'Camiseta de juego',
    hockeyPractice: 'Práctica',
    hockeyFanJersey: 'Camiseta de aficionado',
    hockeyCollarStyleTitle: 'Seleccione un estilo de cuello:',
    hockeyTraditionalCollar: 'Tradicional',
    hockeyModernCollar: 'Moderno',
    hockeyLaceUp: 'Con cordones',
    hockeyFabricDesc: 'Las telas Air Knit y Pro Weight son usadas por equipos profesionales.',
    hockeyAirKnit: 'Tela Air Knit',
    hockeyProWeight: 'Tela Pro Weight',

    // Football Options
    footballOnFieldTitle: 'Arme un paquete de campo para sus jugadores.',
    footballOnFieldDesc: 'Seleccione los artículos de campo que su equipo requiere.',
    footballOffFieldTitle: 'Arme un paquete fuera de campo para sus jugadores y personal.',
    footballOffFieldDesc: 'Deje en blanco si no se requieren artículos fuera de campo.',
    footballHomeJersey: 'Camiseta local',
    footballAwayJersey: 'Camiseta visitante',
    footballPants: 'Pantalón',
    footballPracticeJersey: 'Camiseta de práctica',
    footballWarmupJacket: 'Chaqueta de calentamiento',
    footballSideline: 'Sideline',
    footballTravelSuit: 'Conjunto de viaje',
    footballJerseyStyleTitle: 'Seleccione un estilo de camiseta:',
    footballGameJersey: 'Camiseta de juego',
    footballPractice: 'Práctica',
    footballCompression: 'Compresión',
    footballCollarStyleTitle: 'Seleccione un estilo de cuello:',
    footballFabricDesc: 'Las telas Speed Mesh y Pro Elite son usadas por equipos profesionales.',
    footballSpeedMesh: 'Tela Speed Mesh',
    footballProElite: 'Tela Pro Elite',

    // Lacrosse Options
    lacrosseOnFieldTitle: 'Arme un paquete de campo para sus jugadores.',
    lacrosseOnFieldDesc: 'Seleccione los artículos de campo que su equipo requiere.',
    lacrosseOffFieldTitle: 'Arme un paquete fuera de campo para sus jugadores y personal.',
    lacrosseOffFieldDesc: 'Deje en blanco si no se requieren artículos fuera de campo.',
    lacrosseHomeJersey: 'Camiseta local',
    lacrosseAwayJersey: 'Camiseta visitante',
    lacrosseShorts: 'Shorts',
    lacrossePinnies: 'Petos',
    lacrosseWarmupJacket: 'Chaqueta de calentamiento',
    lacrosseShooter: 'Camiseta shooter',
    lacrosseJerseyStyleTitle: 'Seleccione un estilo de camiseta:',
    lacrosseTraditional: 'Tradicional',
    lacrosseCompression: 'Compresión',
    lacrosseLoose: 'Holgada',
    lacrosseSleeveStyleTitle: 'Seleccione un estilo de manga:',
    lacrosseShortSleeve: 'Manga corta',
    lacrosseLongSleeve: 'Manga larga',
    lacrosseSleeveless: 'Sin mangas',
    lacrosseFabricDesc: 'Las telas Pro Mesh y Elite son usadas por equipos profesionales.',
    lacrosseProMesh: 'Tela Pro Mesh',
    lacrosseElite: 'Tela Elite',

    // Rugby Options
    rugbyOnFieldTitle: 'Arme un paquete de campo para sus jugadores.',
    rugbyOnFieldDesc: 'Seleccione los artículos de campo que su club requiere.',
    rugbyOffFieldTitle: 'Arme un paquete fuera de campo para sus jugadores y personal.',
    rugbyOffFieldDesc: 'Deje en blanco si no se requieren artículos fuera de campo.',
    rugbyHomeJersey: 'Camiseta local',
    rugbyAwayJersey: 'Camiseta visitante',
    rugbyShorts: 'Shorts',
    rugbySocks: 'Medias',
    rugbyTrainingJersey: 'Camiseta de entrenamiento',
    rugbyTracksuit: 'Conjunto deportivo',
    rugbyJerseyStyleTitle: 'Seleccione un estilo de camiseta:',
    rugbyTraditionalJersey: 'Tradicional',
    rugbyFittedJersey: 'Ajustada',
    rugbyLooseJersey: 'Holgada',
    rugbyCollarStyleTitle: 'Seleccione un estilo de cuello:',
    rugbyTraditionalCollar: 'Tradicional',
    rugbyModernCollar: 'Moderno',
    rugbyGrandadCollar: 'Grandad',
    rugbyFabricDesc: 'Las telas Pro Cotton y Elite Poly son usadas por equipos profesionales.',
    rugbyProCotton: 'Tela Pro Cotton',
    rugbyElitePoly: 'Tela Elite Poly',

    // Track Options
    trackOnFieldTitle: 'Arme un paquete de competición para sus atletas.',
    trackOnFieldDesc: 'Seleccione los artículos de competición que su equipo requiere.',
    trackOffFieldTitle: 'Arme un paquete de calentamiento para sus atletas y personal.',
    trackOffFieldDesc: 'Deje en blanco si no se requieren artículos de calentamiento.',
    trackSinglet: 'Camiseta sin mangas',
    trackShorts: 'Shorts',
    trackTights: 'Mallas',
    trackWarmupTop: 'Top de calentamiento',
    trackWarmupPants: 'Pantalón de calentamiento',
    trackTeamJacket: 'Chaqueta del equipo',
    trackTracksuit: 'Conjunto deportivo',
    trackSingletStyleTitle: 'Seleccione un estilo de camiseta:',
    trackRacerback: 'Racerback',
    trackTraditionalSinglet: 'Tradicional',
    trackCompressionSinglet: 'Compresión',
    trackShortsStyleTitle: 'Seleccione un estilo de shorts:',
    trackSplitShorts: 'Split',
    trackVNotchShorts: 'V-Notch',
    trackCompressionShorts: 'Compresión',
    trackFabricDesc: 'Las telas Lightweight y Elite son usadas por atletas profesionales.',
    trackLightweight: 'Tela ligera',
    trackElite: 'Tela Elite',
  },
}

export type TranslationKey = keyof typeof translations['pt-BR']
